import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './base/base.component';
import { FaqComponent } from './base/content/faq/faq.component';
import { editComponent } from './base/content/edit/edit.component';
import { HomeComponent } from './base/content/home/home.component';
import { LoginComponent } from './login/login.component';
import { AdministrationComponent } from './base/content/administration/administration.component';
import { AccessComponent } from './base/content/access-notification/access.component';
import { TranscriptionModuleComponent } from './base/content/transcription-module/transcription-module.component';
import { MsalGuard } from './core/msal';
import { AccessControlGuard } from './core/guards/access-control.guard';
import { AccessControlEditGuard } from './core/guards/access-control-edit.guard';

const routes: Routes = [
  // { path: '', component: LoginComponent },
  { path: 'app', component: BaseComponent, 
    children: [
      { path: '', component:  HomeComponent, canActivate: [AccessControlGuard], runGuardsAndResolvers: 'always' },
      { path: 'faq', component: FaqComponent, canActivate: [AccessControlGuard] },
      { path: 'edit/:idMeeting/:idTranscription/:start', component: editComponent, canActivate: [AccessControlEditGuard] },
      { path: 'admin', component: AdministrationComponent, canActivate: [AccessControlGuard] },
      { path: 'access', component: AccessComponent },
      { path: 'transcription/:idMeeting/:idTranscription/:start', component: TranscriptionModuleComponent, canActivate: [AccessControlGuard] }
    ], 
    canActivate: [ MsalGuard ] 
  },
  { path: '**', redirectTo: 'app?reload=true' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
